import { CampaignContent } from 'schemas/Content.schema';

const VaccinationsCampaignContent: CampaignContent = {
  type: 'Invitation',
  name: 'Choose an invitation campaign name',
  description: 'Choose a name that describes the vaccination campaign and is easy to understand. You could include the vaccine, season and year.',
  example: 'For example, ‘COVID-19 Spring 2025’.',
  startAndEndDateIntro: 'Choose the invitation campaign start and end dates',
  startDateLabel: 'Invitations start date',
  endDateLabel: 'Invitations end date',
};

export default VaccinationsCampaignContent;
